import React, { useContext, useState, useRef } from "react";
import { AppContext } from "../../context/AppContext";
import { useNavigate } from "react-router-dom";
import { Autocomplete } from "@react-google-maps/api";

function MechanicsSearch(props) {
  const { searchMechanics, specialties } = useContext(AppContext);
  let navigate = useNavigate();

  const [coordinates, setCoordinates] = useState({ lat: null, lng: null, state: "" });
  const autocompleteRef = useRef(null);
  const [address, setAddress] = useState("");
  const [specialty, setSpecialty] = useState("");

  const onPlaceChanged = () => {
    const place = autocompleteRef.current.getPlace();

    if (place.geometry) {
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();

      let state = "";
      const addressComponents = place.address_components;
      if (addressComponents) {
        for (let comp of addressComponents) {
          if (comp.types.includes("administrative_area_level_1")) {
            state = comp.long_name;
            break;
          }
        }
      }

      setAddress(place.formatted_address);
      setCoordinates({ lat, lng, state });
    }
  };

  return (
    <>
      <div className="module">
        <h3 className="modtitle">Filter </h3>
        <div className="modcontent ">
          <form className="type_2">
            <div className="table_layout filter-shopby">
              <div className="table_row">

                {/* Specialty dropdown */}
                <div className="table_cell" style={{ zIndex: 103 }}>
                  <legend>Specialty</legend>
                  <select
                    className="form-control grey-border-input"
                    value={specialty}
                    onChange={(e) => setSpecialty(e.target.value)}
                    style={{ height: 38 }}
                  >
                    <option value="">All Specialties</option>
                    {(specialties || []).map((s, i) => (
                      <option key={i} value={s.name === "All" ? "" : s.name}>
                        {s.name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Address autocomplete (optional) */}
                <div className="table_cell" style={{ zIndex: 103 }}>
                  <legend>Address <small style={{ color: '#999' }}>(optional)</small></legend>
                  <Autocomplete
                    onLoad={(autoC) => (autocompleteRef.current = autoC)}
                    onPlaceChanged={onPlaceChanged}
                    className="overide"
                  >
                    <input
                      name="address"
                      type="text"
                      placeholder="Where should the mechanic come?"
                      className="form-control grey-border-input"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                    />
                  </Autocomplete>
                </div>

              </div>
              {/*/ .table_row */}
              <footer className="bottom_box">
                <button
                  type="button"
                  id="sas_search_button0"
                  className="button_grey button_submit"
                  onClick={() => {
                    searchMechanics(specialty, address, coordinates?.lat, coordinates?.lng);
                    navigate("../mechanics", { replace: true });
                  }}
                  style={{ width: "100%" }}
                >
                  Find A Mechanic
                </button>
                {/*Back To Top*/}
                <div className="back-to-top">
                  <i className="fa fa-angle-up" />
                </div>
              </footer>
            </div>
            {/*/ .table_layout */}
          </form>
        </div>
      </div>
    </>
  );
}

export default MechanicsSearch;
